import React from 'react';
import { StudyGuideQuizDataGrid } from './study-guide-quiz-data-grid';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';

export function StudyGuideQuizModal(props) {
  const { data } = props;

  return (
    <DialogContent size="lg">
      <DialogTitle border>Rendimento nos quizzes das aulas</DialogTitle>

      <StudyGuideQuizDataGrid
        data={data}
        height={366}
      />
    </DialogContent>
  );
}
